<template>
  <sign-page
    title-text="医院岗位设置管理"
    :request="request"
    :column-list="columnList"
    @dataUpdate="dataUpdate"
    table-size="large"
    :form-parms-add="formParmsAdd"
    :form-parms-update="formParmsUpdate"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  jobTitleRequest as request
} from '@/api'

export default {
  created () {
    if (this.$authFunsProxy.edit || this.$authFunsProxy.add) {
      this.$store.dispatch('loadCertificateList')
    }
  },
  methods: {
    dataUpdate () {
      this.$store.dispatch('loadJobTitleList', true)
    }
  },
  computed: {
    jobTitleTypes () {
      return this.$store.getters.selectDatas['job_title_type']
    },
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '职称等级',
          key: 'title',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          selectDatas: this.jobTitleTypes,
          label: '岗位类型',
          key: 'type',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          selectDatas: [{key: '初级', label: '初级'}, {key: '中级', label: '中级'}, {key: '高级', label: '高级'}],
          label: '岗位层级',
          key: 'topLevel'
        },
        {
          type: 'select',
          selectDatas: [{key: '员级', label: '员级'}, {key: '助理级', label: '助理级'}, {key: '中级', label: '中级'}, {key: '副高级', label: '副高级'}, {key: '正高级', label: '正高级'}],
          label: '职称级别',
          key: 'mLevel'
        },
        {
          type: 'input',
          label: '等级',
          key: 'lelel',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        // {
        //   type: 'select',
        //   selectDatas: this.$store.getters.certificateList,
        //   label: '需要资格证书',
        //   key: 'needCertificateId'
        // },
        {
          type: 'select',
          selectDatas: [{key: '员级', label: '员级'}, {key: '助理级', label: '助理级'}, {key: '中级', label: '中级'}, {key: '副高级', label: '副高级'}, {key: '正高级', label: '正高级'}],
          label: '需要资格证书等级',
          key: 'needCertificateLevel'
        },
        {
          type: 'select',
          selectDatas: [{key: '员级', label: '员级'}, {key: '助理级', label: '助理级'}, {key: '中级', label: '中级'}, {key: '副高级', label: '副高级'}, {key: '正高级', label: '正高级'}],
          label: '需要职称等级',
          key: 'needMLevel'
        },
        {
          type: 'input',
          label: '需要职称年限',
          key: 'needYear'
        },
        {
          type: 'input',
          label: '实际可用岗位数',
          key: 'num',
          check: {
            required: true,
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'input',
          label: '核准岗位数',
          key: 'yTitle',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        // {
        //   type: 'input',
        //   label: '医师',
        //   key: 'yTitle'
        // },
        // {
        //   type: 'input',
        //   label: '护理',
        //   key: 'hTitle'
        // },
        {
          type: 'input',
          label: '备注',
          key: 'remark'
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = [{
          title: '职称等级',
          sort: true,
          field: 'title'
        },
        {
          title: '岗位类型',
          sort: true,
          field: 'type'
        },
        {
          title: '岗位层级',
          sort: true,
          field: 'topLevel'
        },
        {
          title: '职称级别',
          sort: true,
          field: 'mLevel'
        },
        {
          title: '等级',
          sort: true,
          dataType: Number,
          field: 'lelel'
        },
        // {
        //   title: '需要资格证书',
        //   field: 'needCertificateTitle'
        // },
        {
          title: '需要资格证书等级',
          sort: true,
          field: 'needCertificateLevel'
        },
        {
          title: '需要职称等级',
          sort: true,
          field: 'needMLevel'
        },
        {
          title: '需要职称年限',
          sort: true,
          dataType: Number,
          field: 'needYear',
          render: (h, rowData) => {
            return h('div', rowData && rowData.needYear && rowData.needYear > 100 ? '无限大' : (rowData.needYear ? rowData.needYear : '-'))
          }
        },
        {
          title: '实际可用岗位数',
          sort: true,
          dataType: Number,
          field: 'num'
        },
        {
          title: '核准岗位数',
          sort: true,
          dataType: Number,
          field: 'yTitle'
        },
        // {
        //   title: '医师',
        //   field: 'yTitle'
        // },
        // {
        //   title: '护理',
        //   field: 'hTitle'
        // },
        {
          title: '备注',
          sort: true,
          field: 'remark'
        }]
        return data
      }
    }
  },
  data () {
    return {
      request: request
    }
  }
}
</script>
